// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Review_ReviewModalInner__4srP- {
  max-width: 800px !important;
}

.Review_formWrapper__GcFsC .Review_heading__lG5Yp {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.Review_formWrapper__GcFsC .Review_heading__lG5Yp h1 {
  font: var(--body-font-two);
  color: var(--primary-Text);
  font-weight: 600;
}
.Review_formWrapper__GcFsC .Review_lineItems__bgmSB {
  margin-bottom: 16px;
}
.Review_formWrapper__GcFsC .Review_lineItems__bgmSB .Review_header__APtLB {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 60px;
  gap: 12px;
  align-items: center;
  padding: 0 0 8px 0;
  border-bottom: 1px solid var(--border-default);
}
.Review_formWrapper__GcFsC .Review_lineItems__bgmSB .Review_header__APtLB .Review_headerCell__tIgk\\+ {
  font: var(--body-font-three);
  font-weight: 500;
  color: var(--primary-Text);
}
@media (max-width: 600px) {
  .Review_formWrapper__GcFsC .Review_lineItems__bgmSB .Review_header__APtLB {
    min-width: 520px;
  }
}
.Review_formWrapper__GcFsC .Review_lineItems__bgmSB .Review_body__ETr37 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 0 8px 0;
}
@media (max-width: 600px) {
  .Review_formWrapper__GcFsC .Review_lineItems__bgmSB .Review_body__ETr37 {
    min-width: 520px;
  }
}
.Review_formWrapper__GcFsC .Review_lineItems__bgmSB .Review_bodyCell__nllMP {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 60px;
  gap: 12px;
  align-items: center;
  padding: 4px 0;
  border-bottom: 1px solid var(--border-subtle);
}
.Review_formWrapper__GcFsC .Review_lineItems__bgmSB .Review_bodyCell__nllMP:last-child {
  border-bottom: none;
}
.Review_formWrapper__GcFsC .Review_lineItems__bgmSB .Review_bodyCellContentItemAddon__Pj8oE {
  display: grid;
  grid-template-columns: 24px 1fr;
  gap: 8px;
  padding-left: 12px;
}
.Review_formWrapper__GcFsC .Review_lineItems__bgmSB .Review_addAddOnRow__rI9Aj {
  padding: 8px 0 8px 44px;
  border-bottom: 1px solid var(--border-subtle);
}
.Review_formWrapper__GcFsC .Review_lineItems__bgmSB .Review_addAddOnRow__rI9Aj .Review_addAddOnButton__hVAzc {
  font: var(--body-font-three);
  font-weight: 500;
}
.Review_formWrapper__GcFsC .Review_lineItems__bgmSB .Review_addAddOnRow__rI9Aj img {
  width: 16px;
  height: 16px;
}
.Review_formWrapper__GcFsC .Review_lineItems__bgmSB .Review_bodyCellContentItem__tSJQZ {
  font: var(--body-font-three);
}
@media (max-width: 600px) {
  .Review_formWrapper__GcFsC .Review_lineItems__bgmSB {
    overflow-x: auto;
    min-width: 0;
    -webkit-overflow-scrolling: touch;
  }
}
.Review_formWrapper__GcFsC .Review_summaryWrapper__PuIh9 {
  display: flex;
  justify-content: flex-end;
  padding: 12px 0;
}
.Review_formWrapper__GcFsC .Review_summary__6CcDa {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.7rem 2rem;
}
.Review_formWrapper__GcFsC .Review_summaryItem__yuoMm {
  font: var(--body-font-three);
  color: var(--secondary-Text);
}
.Review_formWrapper__GcFsC .Review_summaryValue__SvFd4 {
  font: var(--body-font-three);
  color: var(--primary-Text);
}
.Review_formWrapper__GcFsC .Review_total__FqIAE {
  color: var(--primary-Text);
  font-weight: 600;
}
.Review_formWrapper__GcFsC .Review_formField__\\+hj76 {
  margin-bottom: 16px;
}
.Review_formWrapper__GcFsC .Review_label__x\\+QTY {
  font: var(--body-font-three);
  color: var(--secondary-Text);
  display: block;
  margin-bottom: 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/Proposal/modal/Review.module.scss"],"names":[],"mappings":"AAAA;EACI,2BAAA;AACJ;;AAII;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AADR;AAGQ;EACI,0BAAA;EACA,0BAAA;EACA,gBAAA;AADZ;AAKI;EACI,mBAAA;AAHR;AAKQ;EACI,aAAA;EACA,2CAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,8CAAA;AAHZ;AAKY;EACI,4BAAA;EACA,gBAAA;EACA,0BAAA;AAHhB;AAMY;EAdJ;IAeQ,gBAAA;EAHd;AACF;AAMQ;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,oBAAA;AAJZ;AAMY;EANJ;IAOQ,gBAAA;EAHd;AACF;AAMQ;EACI,aAAA;EACA,2CAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;EACA,6CAAA;AAJZ;AAMY;EACI,mBAAA;AAJhB;AAQQ;EACI,aAAA;EACA,+BAAA;EACA,QAAA;EACA,kBAAA;AANZ;AASQ;EACI,uBAAA;EACA,6CAAA;AAPZ;AASY;EACI,4BAAA;EACA,gBAAA;AAPhB;AAUY;EACI,WAAA;EACA,YAAA;AARhB;AAaQ;EACI,4BAAA;AAXZ;AAcQ;EAzEJ;IA0EQ,gBAAA;IACA,YAAA;IACA,iCAAA;EAXV;AACF;AAcI;EACI,aAAA;EACA,yBAAA;EACA,eAAA;AAZR;AAeI;EACG,aAAA;EACA,8BAAA;EACA,gBAAA;AAbP;AAgBI;EACI,4BAAA;EACA,4BAAA;AAdR;AAiBI;EACI,4BAAA;EACA,0BAAA;AAfR;AAkBI;EACI,0BAAA;EACA,gBAAA;AAhBR;AAmBI;EACI,mBAAA;AAjBR;AAoBI;EACI,4BAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;AAlBR","sourcesContent":[".ReviewModalInner {\r\n    max-width: 800px !important;\r\n}\r\n\r\n.formWrapper {\r\n\r\n    .heading {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        margin-bottom: 12px;\r\n\r\n        h1 {\r\n            font: var(--body-font-two);\r\n            color: var(--primary-Text);\r\n            font-weight: 600;\r\n        }\r\n    }\r\n\r\n    .lineItems {\r\n        margin-bottom: 16px;\r\n\r\n        .header {\r\n            display: grid;\r\n            grid-template-columns: 2fr 1fr 1fr 1fr 60px;\r\n            gap: 12px;\r\n            align-items: center;\r\n            padding: 0 0 8px 0;\r\n            border-bottom: 1px solid var(--border-default);\r\n\r\n            .headerCell {\r\n                font: var(--body-font-three);\r\n                font-weight: 500;\r\n                color: var(--primary-Text);\r\n            }\r\n\r\n            @media (max-width: 600px) {\r\n                min-width: 520px;\r\n            }\r\n        }\r\n\r\n        .body {\r\n            display: flex;\r\n            flex-direction: column;\r\n            gap: 8px;\r\n            padding: 8px 0 8px 0;\r\n\r\n            @media (max-width: 600px) {\r\n                min-width: 520px;\r\n            }\r\n        }\r\n\r\n        .bodyCell {\r\n            display: grid;\r\n            grid-template-columns: 2fr 1fr 1fr 1fr 60px;\r\n            gap: 12px;\r\n            align-items: center;\r\n            padding: 4px 0;\r\n            border-bottom: 1px solid var(--border-subtle);\r\n\r\n            &:last-child {\r\n                border-bottom: none;\r\n            }\r\n        }\r\n\r\n        .bodyCellContentItemAddon {\r\n            display: grid;\r\n            grid-template-columns: 24px 1fr;\r\n            gap: 8px;\r\n            padding-left: 12px;\r\n        }\r\n\r\n        .addAddOnRow {\r\n            padding: 8px 0 8px 44px;\r\n            border-bottom: 1px solid var(--border-subtle);\r\n\r\n            .addAddOnButton {\r\n                font: var(--body-font-three);\r\n                font-weight: 500;\r\n            }\r\n            \r\n            img {\r\n                width: 16px;\r\n                height: 16px;\r\n            }\r\n        }\r\n\r\n\r\n        .bodyCellContentItem {\r\n            font: var(--body-font-three);\r\n        }\r\n       \r\n        @media (max-width: 600px) {\r\n            overflow-x: auto;\r\n            min-width: 0;\r\n            -webkit-overflow-scrolling: touch;\r\n        }\r\n    }\r\n\r\n    .summaryWrapper {\r\n        display: flex;\r\n        justify-content: flex-end;\r\n        padding: 12px 0;\r\n    }\r\n\r\n    .summary {\r\n       display: grid;\r\n       grid-template-columns: 1fr 1fr;\r\n       gap: 0.7rem 2rem;\r\n    }\r\n\r\n    .summaryItem {\r\n        font: var(--body-font-three);\r\n        color: var(--secondary-Text);\r\n    }\r\n\r\n    .summaryValue {\r\n        font: var(--body-font-three);\r\n        color: var(--primary-Text);\r\n    }\r\n\r\n    .total {\r\n        color: var(--primary-Text);\r\n        font-weight: 600;\r\n    }\r\n\r\n    .formField {\r\n        margin-bottom: 16px;\r\n    }\r\n\r\n    .label {\r\n        font: var(--body-font-three);\r\n        color: var(--secondary-Text);\r\n        display: block;\r\n        margin-bottom: 4px;\r\n    }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ReviewModalInner": `Review_ReviewModalInner__4srP-`,
	"formWrapper": `Review_formWrapper__GcFsC`,
	"heading": `Review_heading__lG5Yp`,
	"lineItems": `Review_lineItems__bgmSB`,
	"header": `Review_header__APtLB`,
	"headerCell": `Review_headerCell__tIgk+`,
	"body": `Review_body__ETr37`,
	"bodyCell": `Review_bodyCell__nllMP`,
	"bodyCellContentItemAddon": `Review_bodyCellContentItemAddon__Pj8oE`,
	"addAddOnRow": `Review_addAddOnRow__rI9Aj`,
	"addAddOnButton": `Review_addAddOnButton__hVAzc`,
	"bodyCellContentItem": `Review_bodyCellContentItem__tSJQZ`,
	"summaryWrapper": `Review_summaryWrapper__PuIh9`,
	"summary": `Review_summary__6CcDa`,
	"summaryItem": `Review_summaryItem__yuoMm`,
	"summaryValue": `Review_summaryValue__SvFd4`,
	"total": `Review_total__FqIAE`,
	"formField": `Review_formField__+hj76`,
	"label": `Review_label__x+QTY`
};
export default ___CSS_LOADER_EXPORT___;
